import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Navigate, useNavigate, useLocation } from 'react-router-dom';

import { searchWorkAssignments, getAttachment, setOrderRating } from '../../actions';
import AssignmentDetail from '../AssignmentDetail';
import {
 DrawerSlide, AssignmentList, IfComponent, Translate,
} from '../../../Share/components';
import './style.scss';
import { status } from '../../../Share/constants';

const propTypes = {
  filters: PropTypes.shape({}),
  assignmentList: PropTypes.arrayOf(PropTypes.shape({})),
  onSearchWorkAssignments: PropTypes.func,
  onGetAttachment: PropTypes.func,
  onOrderRated: PropTypes.func.isRequired,
  // onGetWorkAssignment: PropTypes.func,
  screen: PropTypes.string,
  searchOrder: PropTypes.string,
  location: PropTypes.shape({
    pathname: PropTypes.string,
    state: PropTypes.shape({}),
  }),
  navigate: PropTypes.func,
  showLoadingOverlay: PropTypes.bool,
};

const defaultProps = {
  filters: {},
  assignmentList: [],
  onSearchWorkAssignments: () => { },
  onGetAttachment: () => { },
  // onGetWorkAssignment: () => { },
  screen: 'myAssignment',
  searchOrder: '',
  location: null,
  navigate: () => { },
  showLoadingOverlay: false,
};

const INITAL_STATES = {
  showDetail: false,
  searchOrder: '',
  assignmentDetail: {},
  redirectCancel: false,
};

class SearchResult extends Component {
  constructor(props) {
    super(props);
    this.state = INITAL_STATES;
  }

  componentDidMount() {
    this.executeSearchAssignment();
  }

  componentDidUpdate(prevProps) {
    const { searchOrder } = this.props;
    if (searchOrder !== prevProps.searchOrder) {
      this.executeSearchAssignment();
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.searchOrder !== prevState.searchOrder) {
      return {
        searchOrder: nextProps.searchOrder,
      };
    }
    return null;
  }

  executeSearchAssignment = () => {
    const { onSearchWorkAssignments, searchOrder } = this.props;
    onSearchWorkAssignments(null, null, null, searchOrder, true);
  };

  handleClickCancel = () => {
    this.setState({
      redirectCancel: true,
    });
  };

  onRowClick = (item) => {
    this.setState({
      showDetail: true,
      assignmentDetail: item,
    });
  };

  getPathName = () => {
    const { redirectCancel } = this.state;
    if (redirectCancel) return '/cancel-assignment';
    return '/';
  };

  renderRedirect = () => {
    const { redirectCancel, assignmentDetail } = this.state;
    const { location } = this.props;
    if (redirectCancel) {
      return (
        <Navigate
          to={this.getPathName()}
          state={{
            from: location,
            assignmentDetail,
          }}
          replace
        />
      );
    }
    return null;
  };

  onDrawerClose = () => {
    this.setState({
      showDetail: false,
    });
  };

  redirectToTimeSheet = () => {
    const { assignmentDetail } = this.state;
    const { location, navigate } = this.props;
    navigate('/time-sheet', {
      state: {
        from: location,
        assignmentDetail,
      },
    });
  };

  handleClickTimeReport = () => {
    this.redirectToTimeSheet();
  };

  render() {
    const {
      assignmentList,
      screen,
      searchOrder,
      showLoadingOverlay,
      onOrderRated,
      onGetAttachment,
    } = this.props;
    const { showDetail, assignmentDetail } = this.state;
    return (
      <>
        <IfComponent
          condition={!showLoadingOverlay}
          whenTrue={(
            <IfComponent
              condition={assignmentList.length > 0}
              whenTrue={(
                <>
                  <div className="tv-title-result">
                    <span className="tv-title-result__number">
                      {assignmentList.length}
                    </span>
                    {' '}
                    <Translate content="main.resultsFoundFor" />
                    {' '}
                    <span className="tv-title-result__order">
                      &quot;
                      {searchOrder}
                      &quot;
                    </span>
                  </div>
                  <div className="tv-workassignment__wrapper">
                    <AssignmentList
                      onRowClick={this.onRowClick}
                      items={assignmentList}
                      screen={screen}
                    />
                  </div>
                  <DrawerSlide
                    onCloseClicked={this.onDrawerClose}
                    onOverlayClick={this.onDrawerClose}
                    isVisible={showDetail}
                  >
                    <AssignmentDetail
                      assignment={assignmentDetail}
                      status={status.getByStatusString(assignmentDetail.OrderStatus)}
                      handleClickCancel={() => this.handleClickCancel(assignmentDetail)}
                      handleOrderRate={onOrderRated}
                      handleGetAttachment={onGetAttachment}
                      handleClickTimeReport={this.handleClickTimeReport}
                    />
                  </DrawerSlide>
                </>
              )}
              whenFalse={(
                <div className="tv-not-found">
                  <div className="tv-title-result">
                    <span className="tv-title-result__number">
                      {assignmentList.length}
                    </span>
                    {' '}
                    <Translate content="search.resultFoundFor" />
                    {' '}
                    <span className="tv-title-result__order">
                      &quot;
                      {searchOrder}
                      &quot;
                    </span>
                  </div>
                  <div className="tv-not-found__image" />
                </div>
              )}
            />
          )}
        />
        {this.renderRedirect()}
      </>
    );
  }
}

SearchResult.propTypes = propTypes;
SearchResult.defaultProps = defaultProps;

const mapStateToProps = state => {
  const { assignmentList, searchOrder } = state.workAssignment;
  const { showLoadingOverlay } = state.app;
  return {
    assignmentList,
    searchOrder,
    showLoadingOverlay,
  };
};

const mapDispatchToProps = dispatch => ({
  onSearchWorkAssignments: (s, from, to, o, e) => {
    dispatch(searchWorkAssignments(s, from, to, o, e));
  },
  onOrderRated: (orderIdentifier, rate, comment) => {
    dispatch(setOrderRating(orderIdentifier, rate, comment));
  },
  onGetAttachment: (attachmentIdentifier) => {
    dispatch(getAttachment(attachmentIdentifier));
  },
});

// Create a wrapper component that uses hooks
function SearchResultWithRouter(props) {
  const navigate = useNavigate();
  const location = useLocation();
  const { ...rest } = props;

  return (
    <SearchResult
      {...rest}
      navigate={navigate}
      location={location}
    />
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SearchResultWithRouter);
